import { Send, Sparkles } from "lucide-react"
import { Button } from "@/shared/ui/button.tsx"

const ChatInput = ({
  input,
  setInput,
  handleSend,
}: {
  input: string
  setInput: (value: string) => void
  handleSend: () => void
}) => {
  return (
    <div className="relative w-full mx-auto">
      <div
        className={`
          flex items-center w-full rounded-full border 
          bg-white transition-all duration-200 
          ${input ? "shadow-md border-purple-400" : "border-purple-200"}
          hover:border-gray-300
        `}
      >
        <div className="flex-1 relative">
          <Sparkles
            className={`absolute left-4 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400 transition-opacity duration-200 ${input ? "opacity-0" : "opacity-100"}`}
          />
          <input
            type="text"
            placeholder="Enter you changes"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleSend()}
            className="w-full py-3 px-4 pl-12 bg-transparent outline-none text-sm md:text-base placeholder:text-gray-400"
          />
        </div>
        <Button onClick={handleSend}
          className={`
            rounded-full h-10 w-10 mr-1 transition-all duration-200
            ${input.trim() ? "bg-purple-700 hover:bg-indigo-700" : "bg-gray-300 cursor-not-allowed"}
          `}
          aria-label="Send message">
          <Send className="h-4 w-4" />
          <span className="sr-only">Send</span>
        </Button>
      </div>
    </div>
  )
}

export default ChatInput
